export class MessagingSubscriptionTypeRequest {

  public subscriptionType: string;
}
